import axios from 'axios';

export const linkAccounts = () => axios.post('/link_accounts');
